export default __webpack_public_path__ + "static/media/B-blow It Up.fcf5c464.png";